import { StatusType } from '../ApplicationPage/types';

export type ExpertiseListType = {
  border?: boolean;
};

export type ExpertisePovsScoresType = {
  national_values_is_present_povs?: string;
  corresponding_region_history_povs?: string;
  no_national_conflict_povs?: string;
  lit_language_is_present_povs?: string;
  recommended_povs?: string;
};

export const expertisePovsScores: ExpertisePovsScoresType = {
  national_values_is_present_povs: '',
  corresponding_region_history_povs: '',
  no_national_conflict_povs: '',
  lit_language_is_present_povs: '',
  recommended_povs: '',
};

export type ExpertiseExpertListType = {
  national_values_is_present_povs?: string;
  national_values_is_present_povscomment?: string;
  corresponding_region_history_povs?: string;
  corresponding_region_history_povscomment?: string;
  no_national_conflict_povs?: string;
  no_national_conflict_povscomment?: string;
  lit_language_is_present_povs?: string;
  fio?: string;
  lit_language_is_present_povscomment?: string;
  recommended_povs?: string;
  recommended_povscomment?: string;
  fo_reject_comment?: string;
  id?: number;
  status?: StatusType;
};

export type CollapsableItemsType = {
  national_value?: boolean;
  national_conflicts?: boolean;
  lit_language?: boolean;
  corresponding_region?: boolean;
  recommended?: boolean;
};
